export type Language = 'en' | 'ja';

export const translations = {
  en: {
    // Navigation & Top Bar
    brandName: 'Sym Energy',
    nativeBadge: 'Native',
    wideView: 'Wide View',
    mobileShell: 'Phone Shell',
    customerProfile: 'Customer Profile:',
    lockApp: 'Lock App',
    notifications: 'Notifications',
    langToggle: '日本語',

    // Bottom Tabs
    tabUsage: 'Usage',
    tabBilling: 'Billing',
    tabSync: 'MyPage',
    tabAlerts: 'Alerts',
    tabSettings: 'Settings',

    // Usage Screen
    meterStatusTitle: 'Smart Meter Telemetry Status',
    meterNextDayNotice: 'Next-Day Flash Update · Real-time today data is not provided by regional grid operators',
    yesterdayUsage: "Yesterday's Usage",
    yesterdayCost: "Yesterday's Est. Cost",
    meterStatusConfirmed: 'Confirmed through Yesterday',
    contractRateTier: 'Plan Rate Tiers (3-Tier Weekday)',
    rateDayTier: 'Day Time (09:00 – 16:00)',
    rateLifeTier: 'Life Time (06:00 – 09:00 / 16:00 – 23:00)',
    rateNightTier: 'Night Time (23:00 – 06:00)',
    baseChargeMonth: 'Base Fee',
    meterStreamTitle: 'Smart Meter Telemetry',
    livePulse: 'Next-Day Batch',
    currentDraw: 'Demand Rate',
    peakRateBadge: 'Day Peak',
    offPeakRateBadge: 'Night Off-Peak',
    activeRate: 'Active Rate',
    approxCostHour: '≈ ¥{val} / hour',
    offPeakWindowNote: 'Night rate 22:00 – 08:00 (¥{rate}/kWh)',
    portalSyncBtn: 'Sync MyPage',

    // Period Toggles
    periodHourly: 'Hourly (Yesterday)',
    periodToday: 'Hourly (Yesterday)',
    period7d: '7 Days',
    period30d: '30 Days',
    period12m: '12 Months',
    periodMonthly: 'Monthly',
    periodDaily: 'Daily',
    periodHourlyTab: 'Hourly',
    usageUnitLabel: 'Energy Usage',
    costUnitLabel: 'Electricity Bill',
    unitKwh: 'Usage (kWh)',
    unitCost: 'Cost (¥)',
    periodTotal: 'Period Total',
    periodSum: 'Period Sum',
    legendNightRate: 'Night Time (23:00 – 06:00 Off-Peak ¥18.88)',
    legendLifeRate: 'Life Time (06:00 – 09:00 / 16:00 – 23:00 ¥32.65)',
    legendDayRate: 'Day Time (09:00 – 16:00 Standard ¥26.25)',
    legendPeakRate: 'Day Peak Window (16:00 – 21:00)',
    tier3PricingTitle: '3-Tier Weekday Pricing',
    tier3PricingNotice: 'Weekdays: Day (09:00–16:00), Life (06:00–09:00 / 16:00–23:00), Night (23:00–06:00)',
    tierWeekendNotice: 'Weekends/Holidays: Day (08:00–22:00), Night (22:00–08:00) — No life time',
    vsPrevYear: 'vs Last Year',
    compareWithLastYear: 'Comparison with previous year: ',
    prevYearKwhLabel: 'Last Year Same Month: {val} kWh',
    gridSpecNotice: '※ Per regional transmission operator specifications, daily and hourly telemetry update the following morning; monthly billing updates after invoice settlement (real-time today streaming is not supported).',
    gridSpecNoticeP1: '※ Values reflect preliminary smart meter interval usage provided by regional transmission & distribution operators.',
    gridSpecNoticeP2: '※ Update timings vary across monthly, daily, and hourly charts (real-time intraday data is not supported; values reflect validated intervals through yesterday).',
    baseChargeMonthly: 'Base Fee: ¥1,080/mo (50A)',
    dayTime: 'Day Time',
    lifeTime: 'Life Time',
    nightTime: 'Night Time',
    dayTimeWeekdayDesc: 'Weekdays 09:00–16:00 (Day)',
    lifeTimeWeekdayDesc: 'Weekdays 06-09 / 16-23',
    nightTimeWeekdayDesc: 'Weekdays 23:00–06:00 (Off-Peak)',
    weekend2TierNotice: '※ On weekends and holidays, 2 tiers apply: Day (08:00–22:00: ¥26.25) and Night (22:00–08:00: ¥18.88). No life-time tier.',
    activeLocationNotice1: 'Selected Location (New Contract)',
    statusActive: 'Active',
    statusEnded: 'Ended',
    statusPending: 'Applying',
    statusCancelled: 'Cancelling',
    locationLabel: 'Location',
    activeLocationNotice2: 'New contract location: telemetry will be available after the first billing cycle / meter reading.',
    activeLocationNotice3: 'Switch between registered locations on the top navbar to view historical usage.',
    monthlyListTitle: 'Monthly Electricity Usage & Statement Breakdown',
    monthlyListSubtitle: 'Click any row to inspect daily breakdown',
    tableBillingMonth: 'Billing Month',
    tableReadingDate: 'Reading Date',
    tableDaysCount: 'Days',
    tableUsageKwh: 'Usage (kWh)',
    tableDailyAvg: 'Daily Avg',
    tableBilledAmount: 'Billed (Tax Incl.)',
    tableExclAdj: 'Excl. Adjustments',
    tableCsv: 'CSV',
    dailyListTitle: 'Daily 30-Min Finalized Readings',
    dailyListSubtitle: 'Click date to view hourly interval graph',
    dateCol: 'Date',
    estCostCol: 'Est. Cost',
    thisYearTax: 'This Year (Tax Incl.)',
    lastYearTax: 'Last Year (Tax Incl.)',
    periodTotalDays: 'Period Total ({days} Days)',
    periodRangeDaily: 'Period: {start} – {end} ({days} Days)',
    periodRangeMonthly: 'Period: {start} – {end}',
    prevDay: 'Prev Day',
    nextDay: 'Next Day',
    targetDateLabel: 'Target Date: ',
    finalizedLabel: 'Finalized',
    monthToDateLabel: 'Month to date',
    integrated30Min: '30-min Sum',
    hourlyFlashTitle: '24-hour interval flash values',
    compareTag: 'COMPARE',
    currentPlanTag: 'CURRENT PLAN',
    standardTag: 'STANDARD',
    daysUnit: 'days',

    // Official SymEnergy MyPage Feature: ぴったりプラン診断 (Optimal Plan Diagnostic)
    diagnosticTitle: 'Optimal Plan Diagnostic',
    diagnosticSubtitle: 'Official MyPage Feature: Compares your 30-min usage across SymEnergy plans',
    diagnosticBtn: 'Run Plan Diagnostic',
    diagnosticCloseBtn: 'Close Diagnostic',
    diagnosticAnalysis: 'Based on your actual consumption (58% day / 42% night):',
    diagnosticBestTag: 'RECOMMENDED',
    diagnosticCurrentTag: 'CURRENT',
    diagnosticAnnualSavings: 'Estimated Annual Savings: approx. ¥{val}',
    diagnosticSwitchBtn: 'Switch to {plan}',
    diagnosticSwitchSuccess: 'Plan switch request simulation submitted to SymEnergy!',
    planBasicName: 'Basic Plan',
    planBasicDesc: 'Flat unit rate throughout day & night (standard households)',
    planDayFitName: 'Day Fit Plan',
    planDayFitDesc: 'Cheaper day rates for remote workers, retirees, & daytime appliances',
    planNightFitName: 'Night Fit Plan',
    planNightFitDesc: 'Cheaper night rates (22:00–08:00) for dual-income & EcoCute heaters',

    // Power Source Mix & Non-Fossil Certificate (FAQ MyPage feature)
    powerMixTitle: 'Power Source Mix & Non-Fossil Certificates',
    powerMixSubtitle: 'Clean energy procurement transparency by SymEnergy Inc.',
    powerBiomass: 'Biomass & Eco Hydro',
    powerSolar: 'Solar (Clean Generation)',
    powerWind: 'Wind & Geo Power',
    powerNonFossil: 'Non-Fossil Certificate Ratio',
    co2Title: 'Clean Energy & Carbon Reduction',
    co2Subtitle: 'Sym Energy Renewable Transition Profile',
    co2Avoided: 'CO₂ Avoided',
    co2Unit: 'kg',
    co2Offset: 'Offset',
    efficiencyScore: 'Energy Efficiency',
    efficiencyLevel: 'AAA Rating',
    baseloadFactor: 'Baseload Ratio',

    // Billing Screen
    accountBalance: 'Current Due Balance',
    autoPayStatus: 'Auto-Pay: {method}',
    dueDate: 'Due: {date}',
    billingPeriodLabel: 'Billing Period: {start} to {end}',
    biometricPayBtn: '1-Tap Biometric Payment (¥{amount})',
    processingPayment: 'Processing Secure Payment...',
    viewPdfBtn: 'Web Reading Slip / PDF',
    allBillsPaidTitle: 'All Bills Paid Up to Date',
    allBillsPaidSubtitle: 'Next estimated bill is approx. ¥{amount} on {date}.',
    billingCycleInfoTitle: 'Meter Reading & Contract Overview',
    cycleFrequencyTitle: 'Cycle Frequency',
    cycleFrequencyValue: 'Monthly (12th – 11th)',
    nextReadDate: 'Next read date: {date}',
    planTypeTitle: 'Current Plan',
    dayNightRatePreview: 'Day: ¥{day} / Life: ¥{life} / Night: ¥{night}',
    statementHistoryTitle: 'Billing History & Electric Statements',
    scrapedFromPortalSubtitle: 'Synced directly from SymEnergy MyPage portal records',
    filterAll: 'All',
    filterDue: 'Due',
    filterPaid: 'Paid',
    statusPaidBadge: 'PAID',
    statusDueBadge: 'DUE',
    paidOn: 'Paid: {date}',
    dueOn: 'Due: {date}',
    paymentSuccessTitle: 'Payment Completed!',
    paymentSuccessSubtitle: 'Invoice {inv} has been cleared. Confirmation recorded for {holder}.',
    closeBtn: 'Close',

    // Scraper Screen
    scraperHubTitle: 'SymEnergy MyPage Portal Sync',
    officialUrlBadge: 'Official symenergy.net',
    officialPortalNotice: 'Official Portal Endpoints (SymEnergy Japan)',
    loginUrlTitle: 'Login:',
    dashboardUrlTitle: 'Dashboard:',
    unofficialNote: 'Sym Energy does not offer an official mobile app. This client safely logs into your customer MyPage on this device to parse 30-min meter reads, invoices, and diagnostic data.',
    scrapeNowBtn: 'Sync Latest Data from SymEnergy Portal',
    scrapingInProgress: 'Syncing with SymEnergy MyPage... ({pct}%)',
    credentialsVaultTitle: 'MyPage Credentials Vault',
    secureStorageNote: 'Encrypted in your secure local device sandbox',
    loginUrlField: 'Portal Login URL (Official)',
    dashboardUrlField: 'Dashboard URL',
    emailField: 'Customer ID / Email (お客さま番号 / メール)',
    passwordField: 'MyPage Password',
    updateCredsBtn: 'Update Credentials',
    pasteHtmlBtn: 'Paste Raw MyPage HTML',
    terminalTitle: 'Portal Scraper Ledger',
    terminalSubtitle: 'Session TLS handshake & DOM telemetry',
    clearLogsBtn: 'Clear',
    noLogs: 'No recent scrape activity logs',
    curlDebugTitle: 'Production cURL Debugger',
    curlDebugSubtitle: 'Inspect and copy raw cURL commands for terminal debugging',
    copyCurlBtn: 'Copy cURL',
    copiedCurlBtn: 'Copied!',
    copyAllCurlsBtn: 'Copy All Debug cURLs (Bash Script)',
    viewCurlCommand: 'cURL Command',
    hideCurlCommand: 'Hide cURL',
    localPrivacyTitle: '100% Local & Private (Zero Network Data Transmission)',
    localPrivacySubtitle: 'Your credentials and energy telemetry are processed strictly inside this browser sandbox. No passwords or private data are ever sent over the internet.',
    localImportHubTitle: 'Local Portal Data Import',
    localImportHubSubtitle: 'Sync your real SymEnergy dashboard, meter readings, and usage charts directly from your device',
    dragDropOrPaste: 'Drag & Drop .html / .js file here, or paste page source:',
    parseLocalSourceBtn: 'Parse & Save to Local SQLite WASM',
    bookmarkletTitle: '1-Click Bookmarklet Sync',
    bookmarkletDesc: 'Drag to bookmarks bar, click on SymEnergy MyPage to capture and import instantly',
    consoleScriptTitle: 'Browser Console 1-Liner',
    consoleScriptDesc: 'Open DevTools (F12) on symenergy.net and run this to copy rendered page source:',

    // Manual Paste Modal
    manualPasteTitle: 'Manual MyPage HTML & JS Parser',
    manualPasteSubtitle: 'Extract bills & interval telemetry directly from page HTML or <script> tags',
    pasteInstruction: 'Paste MyPage HTML or <script> source (var days, var amountColumns):',
    loadSampleBtn: 'Load Sample HTML',
    loadJsSampleBtn: 'Load /amounts/318949/daily (JS)',
    parseAndSyncBtn: 'Parse & Sync to App',
    cancelBtn: 'Cancel',
    parseSuccessMsg: 'Successfully extracted {count} records from SymEnergy portal HTML & scripts!',
    parseJsSuccessMsg: 'Extracted {count} interval usage records from JavaScript variables (var amountColumns, var days)!',
    parseFailMsg: 'Could not find SymEnergy billing tables or JavaScript variables in provided input.',

    // Alerts & Notifications Screen
    alertsTitle: 'Billing Cycle Push Alerts',
    alertsSubtitle: 'Real-time alerts for invoices, due dates, and peak rates',
    devicePermissionTitle: 'Device Push Notification Permission',
    devicePermissionActive: 'Push notifications active on this device',
    devicePermissionPrompt: 'Enable push alerts to receive billing notices',
    enablePushBtn: 'Enable Push',
    permissionActiveBtn: 'Active',
    preferencesTitle: 'Alert Preferences',
    alertNewBillTitle: 'New Monthly Statement Issued',
    alertNewBillDesc: 'Push alert as soon as SymEnergy portal publishes new statement',
    alertDueDateTitle: 'Payment Due Countdown',
    alertDueDateDesc: 'Reminder {days} days before payment deadline',
    dayBefore1: '1 day before',
    daysBefore3: '3 days before',
    daysBefore5: '5 days before',
    daysBefore7: '7 days before',
    alertPeakTitle: 'Daytime & Evening Peak Rate Alert',
    alertPeakDesc: 'Alert if household demand exceeds 3.0 kW during expensive hours',
    alertBudgetTitle: 'Monthly Budget Limit Alert',
    alertBudgetDesc: 'Alert when projected electricity cost exceeds ¥{limit}',
    simulatorTitle: 'Push Notification Simulator',
    simulatorSubtitle: 'Test the push notification engine directly:',
    simDueBtn: 'Bill Due Soon',
    simDueDesc: 'Trigger 3-day reminder for ¥8,420',
    simNewBillBtn: 'New Statement',
    simNewBillDesc: 'Trigger monthly bill issued notice',
    simPeakBtn: 'Peak Demand',
    simPeakDesc: 'Trigger 3.8 kW load spike warning',
    simSentMsg: 'Test notification dispatched: "{title}"',
    recentAlertsTitle: 'Recent Notifications',
    newAlertsCount: '{count} new',
    markAllReadBtn: 'Mark all as read',
    amountDueTag: 'Amount Due: ¥{val}',

    // Settings Screen
    securityHeading: 'Biometric Login & Security',
    securitySubheading: 'Protect energy telemetry and 1-tap payments with Face ID / Touch ID',
    requireBioLaunch: 'Require Biometrics on Launch',
    requireBioLaunchDesc: 'Lock app when closed or backgrounded',
    sensorType: 'Biometric Sensor Type',
    faceId: 'Face ID',
    touchId: 'Touch ID',
    autoLockTimer: 'Auto-Lock Timeout',
    lockImmediate: 'Immediately',
    lock1m: 'After 1 minute',
    lock5m: 'After 5 minutes',
    lock15m: 'After 15 minutes',
    changePinBtn: 'Change 4-Digit Fallback PIN',
    testSensorBtn: 'Test Sensor Prompt',
    pinSuccessMsg: 'PIN successfully updated',
    contractHeading: 'Contract & Meter Information',
    providerLabel: 'Utility Provider:',
    accountNoLabel: 'Customer Number (お客さま番号):',
    supplyPointLabel: 'Supply Point ID (供給地点特定番号 22桁):',
    meterSerialLabel: 'Smart Meter Serial (製造番号):',
    contractCapacityLabel: 'Contract Capacity (契約アンペア/容量):',
    paymentMethodLabel: 'Payment Method (お支払い方法):',
    areaLabel: 'Supply Area:',
    planNameLabel: 'Tariff Plan:',
    dayRateLabel: 'Day Unit Rate (09:00 – 17:00):',
    nightRateLabel: 'Night Unit Rate (22:00 – 08:00):',
    baseFeeLabel: 'Basic Monthly Fee:',
    contractEndLabel: 'Contract Expiration:',
    officialLinksHeading: 'SymEnergy Official Links & FAQ',
    officialPortalLogin: 'Official MyPage Login Page',
    officialPortalDash: 'Official MyPage Dashboard',
    officialFaqPage: 'Official MyPage FAQ & Features (FAQページ)',
    dataManageHeading: 'Data Management & Export',
    exportCsvBtn: 'Export Interval Data (CSV)',
    resetCacheBtn: 'Reset Local Cache',
    aboutHeading: 'About Sym Energy Native',
    aboutAppDesc: 'This unofficial native mobile app was crafted to solve mobile navigation issues on the SymEnergy customer portal. All credentials and scraped records are processed locally on your client device.',
    pinModalTitle: 'Set 4-Digit Passcode',
    pinModalDesc: 'Used as fallback when biometric verification is unavailable.',
    savePinBtn: 'Save PIN',

    // PWA Install
    pwaInstallHeading: 'PWA Home Screen App Installation',
    pwaInstallSubheading: 'Install on your iPhone, Android, or PC for a fullscreen standalone experience with offline caching',
    pwaInstalledBadge: 'Installed (Standalone Mode)',
    pwaInstallBtn: 'Install App to Home Screen',
    pwaInstallGuideIOS: 'How to install on iOS Safari',

    // SQLite WASM Local Database
    sqliteSectionTitle: 'Local Database (SQLite WASM)',
    sqliteSectionSubtitle: 'Client-side WebAssembly relational database storing all telemetry, places, and portal statements',
    sqliteEngineLabel: 'Engine',
    sqliteDbSizeLabel: 'Database File Size',
    sqliteTablesLabel: 'Relational Tables',
    sqliteDownloadBtn: 'Download .sqlite Database File',
    sqliteQueryInspector: 'SQL Query Console',
    sqliteRunQueryBtn: 'Run SQL',
    sqliteQueryPlaceholder: 'e.g. SELECT id, demand_number, status, plan_name FROM contracted_places;',
    sqliteQueryResults: 'Query Results',
    sqliteRowsCount: '{count} row(s) returned',
    sqliteError: 'SQL Error: ',

    // Biometric Modal
    bioVerifyTitle: 'Sym Energy Security',
    bioVerifyDesc: 'Authenticate to access energy portal & payment history',
    bioIdentVerified: 'Identity Verified',
    bioDecrypting: 'Decrypting portal session...',
    bioScanning: 'Scanning Face ID...',
    bioRetry: 'Tap icon to retry Face ID',
    bioEnclave: 'Encrypted biometric hardware enclave',
    usePinFallback: 'Use 4-digit PIN Passcode',
    incorrectPin: 'Incorrect PIN. Default is 1234',

    // Invoice Modal
    statementModalTitle: 'Web Meter Reading Slip & Invoice',
    corpName: 'SymEnergy Inc.',
    corpSub: 'シン・エナジー株式会社 (Kobe, Japan)',
    corpRegNo: 'Qualified Invoice Reg: T2140001083492',
    corpAddress: '123-1 Higashi-machi, Chuo-ku, Kobe, Hyogo',
    customerNameLabel: 'CUSTOMER NAME',
    accountSupplyPointLabel: 'ACCOUNT & SUPPLY POINT',
    billingPeriodText: 'Billing Period: {start} to {end}',
    totalUsageText: 'Total Electricity Usage: {kwh} kWh',
    descColumn: 'Item Description',
    amountColumn: 'Amount (JPY)',
    itemBaseCharge: 'Basic Fee (Contract capacity base)',
    itemDayUsage: 'Day Electricity (@¥{rate}/kWh)',
    itemLifeUsage: 'Life Time Electricity (@¥{rate}/kWh)',
    itemNightUsage: 'Night Electricity (@¥{rate}/kWh)',
    itemRenewableLevy: 'Renewable Energy Surcharge (再エネ賦課金)',
    itemTax: 'Consumption Tax (10%)',
    totalDueRow: 'Total Statement Amount Due',
    payStatementBtn: 'Pay Statement (¥{val})',
    downloadJsonBtn: 'Save JSON Statement',
    printBtn: 'Print / PDF Slip',

    // Contract Places & Auto-Sync
    contractPlacesLabel: 'Contract Locations',
    selectPlacePrompt: 'Select Contract Location',
    autoSyncLabel: 'Daily 01:00 AM Auto-Sync',
    offlineModeNotice: 'Viewing offline data stored on device'
  },
  ja: {
    // Navigation & Top Bar
    brandName: 'シン・エナジー',
    nativeBadge: 'Native',
    wideView: 'ワイド表示',
    mobileShell: 'スマホ表示',
    customerProfile: '契約アカウント:',
    langToggle: 'English',
    lockApp: 'アプリをロック',
    notifications: '通知',

    // Bottom Tabs
    tabUsage: '使用量',
    tabBilling: '請求明細',
    tabSync: 'マイページ',
    tabAlerts: '通知',
    tabSettings: '設定',

    // Usage Screen
    meterStatusTitle: 'スマートメーター検針速報',
    meterNextDayNotice: '原則翌日更新 · 一般送配電事業者の仕様により当日のリアルタイム配信はありません',
    yesterdayUsage: '前日合計使用量',
    yesterdayCost: '前日概算電気代',
    meterStatusConfirmed: '前日実績反映済',
    contractRateTier: 'ご契約プラン単価 (平日3段階区分)',
    rateDayTier: 'デイタイム (平日 9:00〜16:00)',
    rateLifeTier: 'ライフタイム (平日 6:00〜9:00 / 16:00〜23:00)',
    rateNightTier: 'ナイトタイム (平日 23:00〜翌6:00 割安)',
    baseChargeMonth: '基本料金',
    meterStreamTitle: 'スマートメーター速報値',
    livePulse: '翌日バッチ更新',
    currentDraw: '瞬時消費電力',
    peakRateBadge: '生活時間ピーク',
    offPeakRateBadge: '夜間格安時間',
    activeRate: '適用電力量料金',
    approxCostHour: '≈ 約¥{val} / 時間',
    offPeakWindowNote: '夜間割安 23時〜翌6時 (¥{rate}/kWh)',
    portalSyncBtn: 'マイページ同期',

    // Period Toggles
    periodHourly: '時間別 (前日)',
    periodToday: '時間別 (前日)',
    period7d: '週別 (7日)',
    period30d: '日別 (30日)',
    period12m: '月別 (12ヶ月)',
    periodMonthly: '月別',
    periodDaily: '日別',
    periodHourlyTab: '時間別',
    usageUnitLabel: '電気使用量',
    costUnitLabel: '電気代',
    unitKwh: '使用量 (kWh)',
    unitCost: '電気料金 (円)',
    periodTotal: '期間合計',
    periodSum: '期間累計',
    legendNightRate: 'ナイトタイム (夜時間 23:00〜翌6:00) ¥18.88 割安',
    legendLifeRate: 'ライフタイム (生活時間 6:00〜9:00 / 16:00〜23:00) ¥32.65',
    legendDayRate: 'デイタイム (昼時間 9:00〜16:00) ¥26.25',
    legendPeakRate: '生活時間ピーク (16:00〜23:00)',
    tier3PricingTitle: 'シン・エナジー 平日3段階料金',
    tier3PricingNotice: '平日: デイタイム(9:00〜16:00)・生活時間(6:00〜9:00 / 16:00〜23:00)・夜時間(23:00〜翌6:00)',
    tierWeekendNotice: '土日祝: デイタイム(8:00〜22:00)・ナイトタイム(22:00〜翌8:00)の2区分（生活時間なし）',
    vsPrevYear: '前年同月比',
    compareWithLastYear: '前年同月との比較: ',
    prevYearKwhLabel: '前年同月実績: {val} kWh',
    gridSpecNotice: '※一般送配電事業者からのデータ連携仕様に基づき、日別・時間別データは翌日、月別データは検針票確定後に更新されます（当日のリアルタイム値は非提供）。',
    gridSpecNoticeP1: '※グラフの数値は一般送配電事業者から提供されるスマートメーターの電気使用量データの速報値を表示しております。',
    gridSpecNoticeP2: '※月別・日別・時間別の各グラフで更新タイミングが異なります（当日リアルタイム値は非提供のため前日までの確定速報値を表示）。',
    baseChargeMonthly: '基本料金: ¥1,080/月 (50A)',
    dayTime: 'デイタイム',
    lifeTime: 'ライフタイム',
    nightTime: 'ナイトタイム',
    dayTimeWeekdayDesc: '平日 9:00〜16:00 (昼時間)',
    lifeTimeWeekdayDesc: '平日 6-9時 / 16-23時',
    nightTimeWeekdayDesc: '平日 23:00〜翌6:00 (割安)',
    weekend2TierNotice: '※土日祝日は、デイタイム (8:00〜22:00: ¥26.25) とナイトタイム (22:00〜翌8:00: ¥18.88) の2区分となります（生活時間なし）。',
    activeLocationNotice1: '選択中のご使用場所（新規契約地点）',
    statusActive: '契約中',
    statusEnded: '契約終了',
    statusPending: '申込手続中',
    statusCancelled: '廃止処理中',
    locationLabel: 'ご使用場所',
    activeLocationNotice2: '新規供給地点のため、初回検針日を迎えるまで確定データは生成されません。',
    activeLocationNotice3: '他の地点の実績を確認するには、上部ナビバーのご使用場所セレクターから切り替えてください。',
    monthlyListTitle: '月別電気料金・使用量明細一覧',
    monthlyListSubtitle: 'クリックで月別日次グラフへジャンプ',
    tableBillingMonth: '請求年月',
    tableReadingDate: '検針日',
    tableDaysCount: '使用日数',
    tableUsageKwh: '使用量(kWh)',
    tableDailyAvg: '1日平均',
    tableBilledAmount: '請求金額(税込)',
    tableExclAdj: '燃調・再エネ除',
    tableCsv: 'CSV',
    dailyListTitle: '日別電気使用実績 (2026年07月10日〜08月09日)',
    dailyListSubtitle: '日付をクリックすると時間別グラフへ',
    dateCol: '月日',
    estCostCol: '概算金額',
    thisYearTax: '今年 (税込)',
    lastYearTax: '前年 (税込)',
    periodTotalDays: '表示期間の合計 ({days}日)',
    periodRangeDaily: 'ご使用期間：{start} ～ {end} ({days}日間)',
    periodRangeMonthly: '表示期間：{start} 〜 {end}',
    prevDay: '前日',
    nextDay: '翌日',
    targetDateLabel: '対象日：',
    finalizedLabel: '確定値',
    monthToDateLabel: '当月（日別積算）',
    integrated30Min: '30分積算',
    hourlyFlashTitle: '24時間スマートメーター速報値',
    compareTag: '比較',
    currentPlanTag: 'ご契約中',
    standardTag: '標準',
    daysUnit: '日',

    // Official SymEnergy MyPage Feature: ぴったりプラン診断
    diagnosticTitle: 'ぴったりプラン診断',
    diagnosticSubtitle: 'マイページ公式機能: 30分ごとの実績値をもとに最適なプランを自動判定',
    diagnosticBtn: 'プラン診断を見る',
    diagnosticCloseBtn: '診断を閉じる',
    diagnosticAnalysis: 'お客さまの実際の使用比率（昼間 58% / 夜間 42%）に基づく試算:',
    diagnosticBestTag: '最安おすすめ',
    diagnosticCurrentTag: '現在ご契約',
    diagnosticAnnualSavings: '年間おトク額（推定）: 約¥{val}',
    diagnosticSwitchBtn: '【{plan}】に変更手続き',
    diagnosticSwitchSuccess: 'シン・エナジーへのプラン変更申込みシミュレーションが完了しました！',
    planBasicName: 'きほんプラン',
    planBasicDesc: '時間帯を問わず一定単価（標準的なご家庭・時間帯を気にせず使いたい方向け）',
    planDayFitName: '昼生活フィットプラン',
    planDayFitDesc: '昼間（9時〜17時）がお得！在宅ワーク・ペット飼育・専業主婦・高齢者世帯向け',
    planNightFitName: '夜生活フィットプラン',
    planNightFitDesc: '夜間（22時〜翌8時）が格安！共働き世帯・エコキュート夜間沸き上げ向け',

    // Power Source Mix & Non-Fossil Certificate
    powerMixTitle: '電源構成 & 非化石証書の使用状況',
    powerMixSubtitle: 'シン・エナジー クリーンエネルギー・再エネ調達情報公開',
    powerBiomass: '木質バイオマス & 小水力',
    powerSolar: '太陽光発電 (クリーン調達)',
    powerWind: '風力・地熱発電',
    powerNonFossil: '非化石証書 (実質再エネ100%)',
    co2Title: '再エネ移行 & 省エネ指標',
    co2Subtitle: 'シン・エナジー クリーンエネルギー指標',
    co2Avoided: 'CO₂削減量',
    co2Unit: 'kg',
    co2Offset: '環境価値',
    efficiencyScore: '省エネ評価',
    efficiencyLevel: 'AAAランク',
    baseloadFactor: '待機電力比率',

    // Billing Screen
    accountBalance: 'ご請求残高',
    autoPayStatus: 'お支払い方法: {method}',
    dueDate: '期日: {date}',
    billingPeriodLabel: '対象検針期間: {start} 〜 {end}',
    biometricPayBtn: '生体認証で1タップ即時決済 (¥{amount})',
    processingPayment: '決済処理中...',
    viewPdfBtn: 'WEB検針票 / 明細PDF',
    allBillsPaidTitle: 'すべてお支払い済みです',
    allBillsPaidSubtitle: '次回検針日の推定電気料金は 約¥{amount} （{date}予定）です。',
    billingCycleInfoTitle: '検針・契約プラン概要',
    cycleFrequencyTitle: '検針サイクル',
    cycleFrequencyValue: '毎月12日〜翌月11日',
    nextReadDate: '次回確定日: {date}',
    planTypeTitle: 'ご契約種別',
    dayNightRatePreview: '昼: ¥{day} / 生活: ¥{life} / 夜: ¥{night}',
    statementHistoryTitle: '請求履歴・電気料金等明細',
    scrapedFromPortalSubtitle: 'シン・エナジー マイページスクレイピング連動データ',
    filterAll: 'すべて',
    filterDue: '未払い',
    filterPaid: '支払い済',
    statusPaidBadge: '決済済',
    statusDueBadge: '未払い',
    paidOn: '決済: {date}',
    dueOn: '期日: {date}',
    paymentSuccessTitle: '決済完了',
    paymentSuccessSubtitle: '請求番号 {inv} の電気料金お支払いが正常に完了しました。ご契約者：{holder} 様宛に電子領収データを記録しました。',
    closeBtn: '閉じる',

    // Scraper Screen
    scraperHubTitle: 'シン・エナジー マイページ同期',
    officialUrlBadge: '公式URL連動',
    officialPortalNotice: '公式ポータル接続先 (SymEnergy Japan)',
    loginUrlTitle: 'ログイン:',
    dashboardUrlTitle: 'ダッシュボード:',
    unofficialNote: '※シン・エナジーには公式モバイルアプリが存在しないため、本アプリがお客さまの端末上でマイページから電力使用量（30分値）および請求明細を自動取得・整形します。',
    scrapeNowBtn: '今すぐマイページから最新データを取得 (スクレイピング実行)',
    scrapingInProgress: 'マイページを同期中... ({pct}%)',
    credentialsVaultTitle: 'マイページ ログイン情報',
    secureStorageNote: '端末ローカルのセキュア領域に暗号化保存されます',
    loginUrlField: 'ログインURL (公式)',
    dashboardUrlField: 'ダッシュボードURL',
    emailField: 'ログインID（メールアドレス または お客さま番号）',
    passwordField: 'マイページ パスワード',
    updateCredsBtn: '設定を更新',
    pasteHtmlBtn: 'マイページHTML手動貼り付け',
    terminalTitle: 'スクレイピング通信ログ',
    terminalSubtitle: 'セッション確立 & DOM抽出履歴',
    clearLogsBtn: 'クリア',
    noLogs: '直近のログはありません',
    curlDebugTitle: '本番デバッグ用 cURL コマンド',
    curlDebugSubtitle: 'ターミナルで直接テストできる各リクエストの cURL を確認・コピー',
    copyCurlBtn: 'cURLをコピー',
    copiedCurlBtn: 'コピー完了！',
    copyAllCurlsBtn: '全デバッグ用cURLをコピー (Bashスクリプト)',
    viewCurlCommand: 'cURL コマンドを表示',
    hideCurlCommand: '閉じる',
    localPrivacyTitle: '100% ローカル完結・外部送信ゼロ',
    localPrivacySubtitle: 'ログイン情報や電力使用量はすべてお手元のブラウザ（SQLite WASM）内でのみ処理されます。パスワードや個人データがインターネットへ送信されることは一切ありません。',
    localImportHubTitle: 'マイページ直接取り込み',
    localImportHubSubtitle: '公式マイページのダッシュボード、検針票、30分値スマートメーターデータを安全に端末へ保存',
    dragDropOrPaste: 'HTML/JSファイルをここにドロップ、またはソースコードを貼り付け:',
    parseLocalSourceBtn: '解析してローカルSQLiteに保存',
    bookmarkletTitle: 'ワンクリック同期ブックマークレット',
    bookmarkletDesc: 'ブックマークバーに登録し、マイページ上でタップするだけでソースを簡単取得',
    consoleScriptTitle: 'ブラウザコンソール抽出コマンド',
    consoleScriptDesc: 'symenergy.net 上で開発者ツール (F12) のコンソールに貼り付けるだけで全ソースをコピー:',

    // Manual Paste Modal
    manualPasteTitle: 'マイページHTML & JS 手動取り込み',
    manualPasteSubtitle: 'HTMLテーブルに加え、<script>タグ内のJS変数 (var days, var amountColumns) からも直接抽出',
    pasteInstruction: 'HTMLソースまたはJSコード (var days, var amountColumns):',
    loadSampleBtn: 'サンプルHTMLを読込',
    loadJsSampleBtn: '318949 日別JSサンプルを読込',
    parseAndSyncBtn: '解析してアプリに反映',
    cancelBtn: 'キャンセル',
    parseSuccessMsg: '{count} 箇所のシン・エナジー請求・契約データを正常に抽出しました！',
    parseJsSuccessMsg: 'JS変数 (var amountColumns, var days) から {count}件の使用量実績を正常に抽出しました！',
    parseFailMsg: 'シン・エナジーの請求テーブルまたはJavaScript変数を検出できませんでした。',

    // Alerts & Notifications Screen
    alertsTitle: '検針・請求プッシュ通知設定',
    alertsSubtitle: '請求確定、支払期日、ピーク電力の注意喚起をリアルタイム配信',
    devicePermissionTitle: '端末プッシュ通知の許可',
    devicePermissionActive: 'このデバイスで通知が有効になっています',
    devicePermissionPrompt: '重要な請求期日を見逃さないよう通知を許可',
    enablePushBtn: '通知を許可',
    permissionActiveBtn: '有効化済',
    preferencesTitle: '通知配信条件のカスタマイズ',
    alertNewBillTitle: '月次ご請求金額の確定通知',
    alertNewBillDesc: 'マイページで新しい明細が発行された瞬間に即時通知',
    alertDueDateTitle: 'お支払期日のカウントダウン通知',
    alertDueDateDesc: '期日の {days}日前にリマインド',
    dayBefore1: '1日前',
    daysBefore3: '3日前',
    daysBefore5: '5日前',
    daysBefore7: '7日前',
    alertPeakTitle: '昼間・夕方ピーク電力アラート',
    alertPeakDesc: '高単価時間帯に電力消費が 3.0 kW を超えた場合に通知',
    alertBudgetTitle: '月間目標予算アラート',
    alertBudgetDesc: '当月の予測電気料金が ¥{limit} を超過見込み時に通知',
    simulatorTitle: '通知テストシミュレーター',
    simulatorSubtitle: 'プッシュ通知およびアプリ内通知の動作を即時テストできます：',
    simDueBtn: '支払期日3日前',
    simDueDesc: '¥8,420 の期日リマインドを送信',
    simNewBillBtn: '請求確定通知',
    simNewBillDesc: '今月の確定明細通知を送信',
    simPeakBtn: 'ピーク電力警告',
    simPeakDesc: '3.8 kW 負荷アラートを送信',
    simSentMsg: 'テスト通知を送信しました: 「{title}」',
    recentAlertsTitle: 'お知らせ・通知履歴',
    newAlertsCount: '{count} 件未読',
    markAllReadBtn: 'すべて既読にする',
    amountDueTag: 'ご請求金額: ¥{val}',

    // Settings Screen
    securityHeading: '生体認証ログイン & セキュリティ',
    securitySubheading: 'Face ID・Touch IDで起動時認証およびワンタップ決済を保護',
    requireBioLaunch: 'アプリ起動時に生体認証を要求',
    requireBioLaunchDesc: 'バックグラウンド復帰時にも自動ロック',
    sensorType: '生体センサー種別',
    faceId: 'Face ID (顔認証)',
    touchId: 'Touch ID (指紋認証)',
    autoLockTimer: '自動ロック時間',
    lockImmediate: '即座にロック',
    lock1m: '1分後',
    lock5m: '5分後',
    lock15m: '15分後',
    changePinBtn: '4桁の暗証番号 (PIN) を変更',
    testSensorBtn: '生体認証テスト',
    pinSuccessMsg: '暗証番号を更新しました',
    contractHeading: 'ご契約・供給地点情報',
    providerLabel: '電力会社名:',
    accountNoLabel: 'お客さま番号:',
    supplyPointLabel: '供給地点特定番号 (22桁):',
    meterSerialLabel: 'スマートメーター製造番号:',
    contractCapacityLabel: 'ご契約容量 (契約アンペア):',
    paymentMethodLabel: 'お支払い方法:',
    areaLabel: '供給エリア:',
    planNameLabel: 'ご契約プラン名:',
    dayRateLabel: '昼間電力量料金 (09:00〜17:00):',
    nightRateLabel: '夜間電力量料金 (22:00〜08:00):',
    baseFeeLabel: '基本料金 (月額換算):',
    contractEndLabel: '契約期間満了日:',
    officialLinksHeading: 'シン・エナジー公式リンク & FAQ',
    officialPortalLogin: '公式マイページ ログイン',
    officialPortalDash: '公式マイページ ダッシュボード',
    officialFaqPage: '公式マイページでできること (FAQガイド)',
    dataManageHeading: 'データ管理 & エクスポート',
    exportCsvBtn: '電力使用実績データ出力 (CSV)',
    resetCacheBtn: 'キャッシュを初期化',
    aboutHeading: '本アプリについて (SymEnergy Native)',
    aboutAppDesc: '本アプリは、シン・エナジー株式会社 (SymEnergy Inc.) のWEBマイページをスマートフォンから快適に閲覧・管理するために設計された非公式ネイティブクライアントです。認証情報およびスクレイピングデータは端末内のみでセキュアに保持されます。',
    pinModalTitle: '暗証番号 (PIN) の設定',
    pinModalDesc: '生体認証が利用できない場合の予備4桁コードを設定します。',
    savePinBtn: '保存する',

    // PWA Install
    pwaInstallHeading: 'PWA ホーム画面アプリのインストール',
    pwaInstallSubheading: 'iPhone、Android、またはPCのホーム画面にインストールして、ブラウザ枠なしの全画面ネイティブアプリとしてオフラインでも高速動作します',
    pwaInstalledBadge: 'インストール済み（スタンドアローン起動中）',
    pwaInstallBtn: 'アプリをホーム画面にインストール',
    pwaInstallGuideIOS: 'iOS Safariでのインストール手順',

    // SQLite WASM Local Database
    sqliteSectionTitle: 'ローカルデータベース (SQLite WASM)',
    sqliteSectionSubtitle: 'スマートメーター30分値・検針票・契約場所データを端末内WebAssemblyリレーショナルDBに保存',
    sqliteEngineLabel: 'エンジン',
    sqliteDbSizeLabel: 'DBファイルサイズ',
    sqliteTablesLabel: 'リレーショナルテーブル',
    sqliteDownloadBtn: '.sqlite データベースファイルを書き出し',
    sqliteQueryInspector: 'SQLクエリコンソール',
    sqliteRunQueryBtn: 'SQL実行',
    sqliteQueryPlaceholder: '例: SELECT id, demand_number, status, plan_name FROM contracted_places;',
    sqliteQueryResults: 'クエリ実行結果',
    sqliteRowsCount: '{count} 件取得',
    sqliteError: 'SQL実行エラー: ',

    // Biometric Modal
    bioVerifyTitle: 'シン・エナジー セキュリティ認証',
    bioVerifyDesc: 'Face IDまたは暗証番号でマイページ情報にアクセスします',
    bioIdentVerified: '認証が完了しました',
    bioDecrypting: 'セキュアセッションを復号中...',
    bioScanning: 'Face IDで顔認証中...',
    bioRetry: 'タップしてFace IDを再試行',
    bioEnclave: 'セキュアハードウェアエンクレーブ暗号化',
    usePinFallback: '4桁の暗証番号 (PIN) を使用',
    incorrectPin: '暗証番号が正しくありません (初期値: 1234)',

    // Invoice Modal
    statementModalTitle: 'WEB検針票・電気料金等請求明細書',
    corpName: 'シン・エナジー株式会社',
    corpSub: 'SymEnergy Inc. (旧・株式会社白の風)',
    corpRegNo: '適格請求書発行事業者登録番号: T2140001083492',
    corpAddress: '兵庫県神戸市中央区東町123番地1',
    customerNameLabel: 'ご契約者名',
    accountSupplyPointLabel: 'お客さま番号 / 供給地点',
    billingPeriodText: 'ご請求対象期間: {start} 〜 {end}',
    totalUsageText: 'ご使用量合計: {kwh} kWh',
    descColumn: '明細項目',
    amountColumn: '金額 (円)',
    itemBaseCharge: '基本料金 (契約容量ベース)',
    itemDayUsage: '電力量料金【昼間】(@¥{rate}/kWh)',
    itemLifeUsage: '電力量料金【生活時間】(@¥{rate}/kWh)',
    itemNightUsage: '電力量料金【夜間】(@¥{rate}/kWh)',
    itemRenewableLevy: '再生可能エネルギー発電促進賦課金等',
    itemTax: '消費税等 (10%)',
    totalDueRow: 'ご請求合計金額 (税込)',
    payStatementBtn: '今すぐ支払う (¥{val})',
    downloadJsonBtn: '明細データ保存 (JSON)',
    printBtn: '印刷 / 検針票PDF',

    // Contract Places & Auto-Sync
    contractPlacesLabel: 'ご契約場所一覧',
    selectPlacePrompt: 'ご使用場所を選択',
    autoSyncLabel: '毎日午前1:00 定時自動同期',
    offlineModeNotice: '端末保存のオフラインデータを表示中'
  }
};
